
import Vue from "vue";
import { DocumentLayoutLogoBase } from "@/utils/documents/layout-logo-base";

export default Vue.extend({
	data(){
		return {
			HideOnPdfOnPrint: false,
			HideOnPdfOnEmailSend: false,
			HideOnPdfOnDownload: false,
		};
	},
	props: {
		value: {
			type: Object as ()=>DocumentLayoutLogoBase,
			required: true
		}
	},
	watch: {
		logo: {
			immediate: true,
			handler(){
				this.HideOnPdfOnPrint = this.value.HideOnPdfOnPrint;
				this.HideOnPdfOnEmailSend = this.value.HideOnPdfOnEmailSend;
				this.HideOnPdfOnDownload = this.value.HideOnPdfOnDownload;
			}
		}
	},
	methods: {
		submit(){
			this.value.HideOnPdfOnPrint = this.HideOnPdfOnPrint;
			this.value.HideOnPdfOnEmailSend = this.HideOnPdfOnEmailSend;
			this.value.HideOnPdfOnDownload = this.HideOnPdfOnDownload;
			this.close();
		},
		close(){
			this.$emit("close");
		},
	},
	i18nEx: {
		componentPrefix: "components.layout-editor"
	}
});
